import React, { Component } from 'react';
import Auth from 'j-toker';
import { toFriendlyDateString } from 'helpers/Formatter';
import './Chat.css';

export default class ConversationHeader extends Component {
  render() {
    let name, website;
    if (this.props.landlordDetails) {
      name = this.props.landlordDetails.name;
      website = this.props.landlordDetails.website;
    }

    const userType = Auth.user.type.toLowerCase();
    let conversation = this.props.conversation;
    if (!conversation) {
      conversation = {
        id: 0,
        name: 'Conversation Name',
        cotenants: [],
      };
    }
    const cotenants = conversation.cotenants.map(c => c.name).join(', ');

    let createdAt;
    if (conversation.created_at) {
      createdAt = toFriendlyDateString(new Date(conversation.created_at));
    }

    let [title, subtitle] = ['', ''];
    if (userType === 'lead') {
      title = (
        <span style={{ margin: '5px 0 1px 0', textTransform: 'capitalize' }}>
          <a href={website}>{name}</a>
          <p style={{ float: 'right', display: 'inline' }}>
            Created on <span style={{ fontSize: '14px' }}>{createdAt}</span>
          </p>
        </span>
      );
      subtitle = <p>{`${conversation.name} - ${cotenants}`}</p>;
    } else {
      // agent
      title = (
        <span style={{ margin: '5px 0 1px 0', textTransform: 'capitalize' }}>
          <p style={{ display: 'inline' }}>{conversation.name}</p>
          <p style={{ float: 'right', display: 'inline' }}>
            Created on <span style={{ fontSize: '14px' }}>{createdAt}</span>
          </p>
        </span>
      );
      if (conversation.is_for_active_lease) {
        subtitle = (
          <span>
            <span style={{ color: '#4e4e4e' }}>Tenants: </span>
            <span>{cotenants}</span>
          </span>
        );
      } else {
        subtitle = (
          <span>
            <span style={{ color: '#4e4e4e' }}>Applicants: </span>
            <span>{cotenants}</span>
          </span>
        );
      }
    }

    return (
      <div className="row">
        <div>{title}</div>
        <div>{subtitle}</div>
      </div>
    );
  }
}
